import { gql } from "@apollo/client";

export default gql`
  query getProfileQuery($userId: Int!) {
    user(userId: $userId) {
      id
      name
      firstName
      email
      avatar
      isInCurrentUserReportingTree
      managersList {
        id
        name
        avatar
      }
      primaryManager {
        id
        name
        firstName
        email
      }
    }
  }
`;
